module.exports = __webpack_public_path__ + "media/country_flags/sg-01ffb8ba.png";